// @ts-nocheck
import { resolveColor } from "@insite/mobius/utilities";
import { IconDefinitionProps } from "@toolkit/Framework/Types/Icon";

export default <T extends IconDefinitionProps>(props: T): T => {
    const { size, theme, color, textColor } = props || {};

    const result: T = {
        ...props,
        size: typeof size === "number" ? `${size}px` : size,
        color: color && theme ? resolveColor(color, theme) : "currentColor",
        textColor: textColor && theme ? resolveColor(textColor, theme) : "white",
    };

    if (!textColor && color) {
        const contrastColor = `${color}.contrast`;
        const resolvedContrastColor = theme ? resolveColor(contrastColor, theme) : contrastColor;

        if (resolvedContrastColor !== contrastColor) {
            result.textColor = resolvedContrastColor;
        }
    }

    return result;
};
